import { lazy } from 'react';

export const auditPagesConfigs = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/audit/dashboard',
        component: lazy(() => import('./dashboard')),
      },
    ],
  },
]